"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sizes = void 0;
var react_jss_1 = require("react-jss");
var theme_1 = require("../../../mantine-theme/src");
exports.sizes = {
    xs: 180,
    sm: 240,
    md: 320,
    lg: 360,
    xl: 500,
    full: '100%',
};
function getPositionStyles(_a) {
    var position = _a.position, size = _a.size;
    switch (position) {
        case 'top':
            return { top: 0, left: 0, right: 0, height: theme_1.getSizeValue({ size: size, sizes: exports.sizes }) };
        case 'bottom':
            return { bottom: 0, left: 0, right: 0, height: theme_1.getSizeValue({ size: size, sizes: exports.sizes }) };
        case 'right':
            return { bottom: 0, top: 0, right: 0, width: theme_1.getSizeValue({ size: size, sizes: exports.sizes }) };
        case 'left':
            return { bottom: 0, top: 0, left: 0, width: theme_1.getSizeValue({ size: size, sizes: exports.sizes }) };
        default:
            return null;
    }
}
exports.default = react_jss_1.createUseStyles({
    noOverlay: {},
    wrapper: {
        '&:not($noOverlay)': {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
        },
    },
    drawer: function (_a) {
        var size = _a.size, position = _a.position;
        return (__assign(__assign({}, getPositionStyles({ position: position, size: size })), { maxWidth: '100%', maxHeight: '100vh', position: 'fixed', outline: 0 }));
    },
}, { link: true });
